module.exports = __webpack_public_path__ + "img/ypj.7e03db5e.png";